import * as Yup from 'yup';

export interface ProgramClassForm {
    name: string;
    startDate?: Date;
    finishDate?: Date | null | undefined;
    enrollmentsCount?: number;
    enableCourseCertificate?: boolean;
    enableProgramCertificate?: boolean;
    mandatory?: boolean;
}

export const programClassSchema: Yup.ObjectSchema<ProgramClassForm> = Yup.object().shape<ProgramClassForm>({
    name: Yup.string().required(),
    startDate: Yup.date().required(),
    finishDate: Yup.date()
        .notRequired()
        .nullable()
        .default(undefined),
    enrollmentsCount: Yup.number().notRequired(),
    enableCourseCertificate: Yup.bool().notRequired(),
    enableProgramCertificate: Yup.bool().notRequired(),
    mandatory: Yup.bool().notRequired(),
});

export const formInitialState = {
    name: '',
    startDate: undefined,
    finishDate: undefined,
    enrollmentsCount: 0,
    enableCourseCertificate: false,
    enableProgramCertificate: false,
    mandatory: false,
};

export const formErrors = {
    nameError: false,
    startDateError: false,
    finishDateError: false,
    enrollmentsCountError: false,
};
